import React from "react";

import InvoiceGrid from "pages/invoices/component/invoice.grid";
import { downloadInvoicePdf, getInvoiceDataSource, Invoice, InvoiceStatus } from "pages/invoices/invoices.service";

import ActionsPanelComponent from "components/dxf-grid/actions-panel.component";
import { useNavigate } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useMutation} from "react-query";

const UnpaidInvoicePage = () => {
  const dataSource = React.useMemo(() => getInvoiceDataSource(InvoiceStatus.Unpaid), []);
  return <InvoiceGrid dataSource={dataSource} actions={InvoiceActions} invoiceStatus="unpaid" />;
};

function InvoiceActions({ data }: any) {
  const navigate = useNavigate();
  const {t} = useTranslation('invoices');
  const invoice = data as Invoice;

  const downloadPdfMutation = useMutation(() => downloadInvoicePdf(invoice))

  const actions = [
    {
      label: t('pay'),
      action: () => navigate(`/payment-details?invoiceId=${invoice.id}`)
    },
    {
      label: t('download'),
      action: () => downloadPdfMutation.mutate()
    },
    {
      label: t('need-help-with-invoice'),
      action: () => navigate("/tickets", { state: { isAddingTicket: true, invoice } })
    }
  ];
  return <ActionsPanelComponent actions={actions} isLoading={downloadPdfMutation.isLoading} />;
}

export default UnpaidInvoicePage;
